import countryLib from "country-list";
import langLib from "langs";
import { Dictionary, ListFields } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";

interface LangListData {
  dropdownList: ListFields;
  shortToName: Dictionary<string>;
  nameToShort: Dictionary<string>;
}

const langListOut: LangListData = {
  dropdownList: [],
  shortToName: {},
  nameToShort: {},
};

const langList = langLib.all().reduce((out, item) => {
  const name = $t(item.name);
  out.dropdownList.push({
    text: name,
    value: item[1],
  });
  out.shortToName[item[1]] = name;
  out.nameToShort[name] = item[1];
  return out;
}, langListOut);

const codeList = Object.keys(countryLib.getCodeList()).reduce((out, key) => {
  out[key.toUpperCase()] = countryLib.getCodeList()[key];
  return out;
}, {} as Dictionary<string>);

export function mapToDropdownList(data: Dictionary<string>) {
  const resultOut: ListFields = [];
  return Object.keys(data).reduce((out, key) => {
    out.push({
      text: $t(data[key]),
      value: key,
    });
    return out;
  }, resultOut);
}

const countryList = mapToDropdownList(codeList);

export function listToDropdownList(list: string[]) {
  const resultOut: ListFields = [];
  return list.reduce((out, item) => {
    out.push({
      text: $t(item),
      value: item,
    });
    return out;
  }, resultOut);
}

export function dropdownListToMap(list: ListFields, key = "value") {
  // Create K -> V map of list.
  const resultOut: Dictionary<string> = {};
  return list.reduce((out, item) => {
    out[item.value || key] = $t(item.text);
    return out;
  }, resultOut);
}

export { countryList, codeList, langList };
